export const CustomProjectModalTranslations = {
  en: {
    customProjectModal: {
      step1: {
        projectName: "Performance Name",
        description: "Description",
        system: "System",
        voltages: "Voltage",
        technology: "Technology",
        refrigerant: "Refrigerant",
        capacities: "Nominal Capacity",
        heatExchanger: "Heat Exchanger",
        efficiency: "Efficiency",
        leavingWaterTemp: "Leaving Water Temperature",
        evaporatingTemperature: "Evaporating Temperature",
        enteringWaterTemp: "Entering Water Temperature",
        location: "Location",
        ambianceTemperature: "Ambient Temperature",
        amsl: "AMSL",
        pressureDrop: "Pressure Drop",
        selectOption: "Select an option",
        errors: "This field is required",

        fluidType: "Fluid Type",
        fluidConcentration: "Fluid Concentration",
        water: "Water",
        propyleneGlycol: "Propylene Glycol",

        next: "Next",
      },

      step2: {
        centrifugalInfo:
          "The fields below are displayed due to the selected Centrifugal technology and apply only to Centrifugal systems.",

        modelSize: "Model Size",
        rangeSelection: "Range Selection",
        runningCapacity: "Running Capacity",
        isEconomizer: "Is economizer",
        approachTemperature: "Approach Temperature",
        economizerSuperheat: "Economizer Superheat",

        compressorModel: "Compressor Model",
        coolingCapacityPerCompressor: "Cooling Capacity per Compressor",
        kwPerCompressor: "kW per Compressor",
        ampsPerCompressor: "Amps per Compressor",
        heatCapacityPerCompressor: "Heat Capacity per Compressor",
        compressorRLA: "Compressor RLA",
        compressorLRA: "Compressor LRA",

        circuitCount: "Circuit Count",
        compressorQtyPerCircuit: "Compressor Quantity per Circuit",

        condenserModel: "Condenser Model",
        condenserQtyPerCircuit: "Condenser Quantity per Circuit",

        fanModel: "Fan Model",
        fanQtyPerCircuit: "Fan Quantity per Circuit",

        evaporatorModel: "Evaporator Model",
        evaporatorQty: "Evaporator Quantity",

        condensingTemperature: "Condensing Temperature",
        subcooling: "Subcooling",
        evaporatingTemperature: "Evaporating Temperature",
        superheat: "Superheat",

        back: "Back",
        create: "Calculate custom",
      },
    },
  },

  es: {
    customProjectModal: {
      step1: {
        projectName: "Nombre de la hoja",
        description: "Descripción",
        system: "Sistema",
        voltages: "Voltaje",
        technology: "Tecnología",
        refrigerant: "Refrigerante",
        capacities: "Capacidad nominal",
        heatExchanger: "Intercambiador de calor",
        efficiency: "Eficiencia",
        leavingWaterTemp: "Temperatura de salida del agua",
        evaporatingTemperature: "Temperatura de Evaporación",
        enteringWaterTemp: "Temperatura de entrada del agua",
        location: "Ubicación",
        ambianceTemperature: "Temperatura ambiente",
        amsl: "AMSL",
        pressureDrop: "Caída de presión",
        selectOption: "Selecciona una opción",
        errors: "Este campo es obligatorio",
        next: "Siguiente",
        fluidType: "Tipo de fluido",
        fluidConcentration: "Concentración del fluido",
        water: "Agua",
        propyleneGlycol: "Propilen Glicol",
      },

      step2: {
        centrifugalInfo:
          "Los siguientes campos se muestran debido a la tecnología Centrífuga seleccionada y aplican únicamente a sistemas Centrífugos.",

        modelSize: "Tamaño del modelo",
        rangeSelection: "Selección de rango",
        runningCapacity: "Capacidad en operación",
        isEconomizer: "Tiene economizador",
        approachTemperature: "Temperatura de aproximación",
        economizerSuperheat: "Sobrecalentamiento del economizador",

        compressorModel: "Modelo del compresor",
        coolingCapacityPerCompressor: "Capacidad de enfriamiento por compresor",
        kwPerCompressor: "kW por compresor",
        ampsPerCompressor: "Amperes por compresor",
        heatCapacityPerCompressor: "Capacidad térmica por compresor",
        compressorRLA: "RLA del compresor",
        compressorLRA: "LRA del compresor",

        circuitCount: "Cantidad de circuitos",
        compressorQtyPerCircuit: "Cantidad de compresores por circuito",

        condenserModel: "Modelo del condensador",
        condenserQtyPerCircuit: "Cantidad de condensadores por circuito",

        fanModel: "Modelo del ventilador",
        fanQtyPerCircuit: "Cantidad de ventiladores por circuito",

        evaporatorModel: "Modelo del evaporador",
        evaporatorQty: "Cantidad de evaporadores",

        condensingTemperature: "Temperatura de condensación",
        subcooling: "Subenfriamiento",
        evaporatingTemperature: "Temperatura de evaporación",
        superheat: "Sobrecalentamiento",

        back: "Volver",
        create: "Calcular personalizado",
      },
    },
  },
};
